/** @jsx jsx */

import { Fragment } from 'react';

import { jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { getAppVersionUrl } from 'app/developer-v3/utils';

import type { VersionParams } from 'app/developer-v3/types/version';

type Props = {
  params: VersionParams;
};

const HelpBoxApiConfig = (props: Props) => (
  <Fragment>
    Add the API endpoint details where Zapier will get data from your app. Go to
    the{' '}
    <Link
      href={`${getAppVersionUrl(
        props.params.id,
        props.params.version
      )}/advanced/legacy`}
    >
      Advanced Legacy Web Builder
    </Link>{' '}
    settings if your integration uses REST hooks, or if you need to customize
    the API call or response parsing with JavaScript code.{' '}
    <Link
      href="https://docs.zapier.com/platform/reference/legacy-scripting"
      target="_blank"
    >
      Learn more
    </Link>
    .
  </Fragment>
);

export default HelpBoxApiConfig;
